import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { notification, Skeleton } from 'antd';
import { XThemeVoiceAssTableCard } from '../../VoiceAssistanceStyle';

// Import your existing appeal letter components
import VAAppealLetterLoader from './VAAppealLetterLoader';
import VAAppealLetterPreview from './VAAppealLetterPreview';
import VAAppealLetterSentLoader from './VAAppealLetterSentLoader';
import { saveAs } from 'file-saver';
// Import actions
import {
	getAppealLetterApi,
	getAppealLetterReset,
} from '../../../../actions/getAppealLetterAction';
import { editCaseApi, editCaseReset } from '../../../../actions/editCaseAction';
import {
	saveAppealLetterApi,
	saveAppealLetterReset,
} from '../../../../actions/saveAppealLetterAction';
import {
	getAnalysisApi,
	getAnalysisReset,
} from '../../../../actions/getAnalysisAction';
import { XForm } from '../../../../styles/GlobalThemeStyle';
import moment from 'moment';
import axios from 'axios';
import {
	checkModulePermissions,
	getUserToken,
	toTitleCase,
} from '../../../../utils/helper';
import config from '../../../../config';
import {
	getVerifyApproveAppealLetterUserListApi,
	getVerifyApproveAppealLetterUserListReset,
} from '../../../../actions/getVerifyApproveAppealLetterUserListAction';
import VASendAppealLetter from './VASendAppealLetter';
import VAAppealLetterDownload from './VAAppealLetterDownload';

const VAAppealLetterController = (props) => {
	const {
		action,
		actionParameters,
		setProcessingAction,
		onUserInputRequired,
		getAppealLetter,
		getAppealLetterState,
		getAppealLetterReset,
		editCase,
		editCaseState,
		editCaseReset,
		getVerifyApproveAppealLetterUserList,
		getVerifyApproveAppealLetterUserListState,
		getVerifyApproveAppealLetterUserListReset,
		getAnalysis,
		getAnalysisState,
		getAnalysisReset,
		saveAppealLetter,
		saveAppealLetterState,
		saveAppealLetterReset,
	} = props;

	// State management
	const [id, setId] = useState(null);
	const [currentView, setCurrentView] = useState('skeleton');
	const [currentViewSetter, setCurrentViewSetter] = useState('preview');
	const [appealForm] = XForm.useForm();
	const editorRef = useRef(null);
	const [appealLetterContent, setAppealLetterContent] = useState('');
	const [appealLetterHeader, setAppealLetterHeader] = useState('');
	const [appealLetterFooter, setAppealLetterFooter] = useState('');
	const [appealLetterLoading, setAppealLetterLoading] = useState(false);
	const [editAppealLetterLoading, setEditAppealLetterLoading] =
		useState(false);
	const [selectMember, setSelectMember] = useState(1);
	const [appealLetterUsers, setAppealLetterUsers] = useState([]);
	const [editFlag, setEditFlag] = useState();

	const [chatOpen, setChatOpen] = useState(false);
	const [isMdDisabled, setIsMdDisabled] = useState(false);
	const [isCodingDisabled, setIsCodingDisabled] = useState(false);
	const [activeKey, setActiveKey] = useState('1');
	const [appealLetterType, setAppealLetterType] = useState('');
	const [patientDetails, setPatientDetails] = useState({});

	const sendToCodingTeam = (formValues) => {
		setAppealLetterLoading(true);
		editCase({
			appeal_letter_remarks: formValues.appeal_letter_remarks,
			appeal_letter_assigned_to: formValues.appeal_letter_assigned_to,
			id: id,
			status: 'sent_for_verification',
			status_remarks: 'Appeal Letter sent for Verification',
			appeal_letter: appealLetterContent,
			type: appealLetterType,
			sent_to_coding_team: true,
		});
	};
	const [isAppealVerifyApproveModalOpen, setIsAppealVerifyApproveModalOpen] =
		useState(
			isCodingDisabled
				? ['', '', '']
				: [
						'Send To Coding Team for Verification',
						sendToCodingTeam,
						'coding-team',
				  ],
		);
	const [downloadLoading, setDownloadLoading] = useState(false);
	const [formData, setFormData] = useState({});
	const [patientData, setPatientData] = useState(patientDetails || {});
	const [editAppealLetterSelected, setEditAppealLetterSelected] =
		useState(false);
	const [showEditAppealLetter, setShowEditAppealLetter] = useState(false);
	const [mainDataLoading, setMainDataLoading] = useState(false);
	const [loading, setLoading] = useState(false);
	const [isAnalyse, setIsAnalyse] = useState(false);
	// for send appeal letter
	const [previewTitle, setPreviewTitle] = useState('Upload Acknowledgement');
	const [displayFaxUpload, setDisplayFaxUpload] = useState(false);
	const [displayEmailContent, setDisplayEmailContent] = useState(false);
	const [letterDownloaded, setLetterDownloaded] = useState(false);
	const [successModal, setSuccessModal] = useState(false);
	const [sendLetterLoading, setSendLetterLoading] = useState(false);
	const [firstTime, setFirstTime] = useState(true);

	// Initialize with case ID from action parameters
	useEffect(() => {
		if (actionParameters && actionParameters.case_id) {
			setId(actionParameters.case_id);
		}
		if (action === 'edit_appeal_letter') {
			setCurrentViewSetter('preview');
			setEditAppealLetterSelected(true);
			setEditFlag(true);
		}
		if (action === 're_generate_appeal_letter') {
			setCurrentViewSetter('preview');
			setEditAppealLetterSelected(false);
			setEditFlag(false);
		}
		if (action === 'send_appeal_letter') {
			setCurrentViewSetter('send_appeal_letter');
			setEditAppealLetterSelected(false);
			setEditFlag(false);
		}
		if (action === 'download_appeal_letter') {
			setCurrentViewSetter('download_appeal_letter');
			setEditAppealLetterSelected(false);
			setEditFlag(false);
		}
	}, [actionParameters, action]);

	useEffect(() => {
		if (id) {
			// This is a page refresh; call the API
			setLoading(true);
			setIsAnalyse(true);
			getAnalysis({
				id: id,
				process_type: actionParameters?.process_type || 'rc',
			});
		}
	}, [id]);

	useEffect(() => {
		if (getAnalysisState.apiState === 'loading') {
			setMainDataLoading(true);
			// setCurrentView('skeleton');
		}
		if (getAnalysisState.apiState === 'success') {
			setMainDataLoading(false);
			// setCurrentView('loader');
			setAppealLetterLoading(false);
			setPatientData(getAnalysisState.data.case_details);
		}
		if (getAnalysisState.apiState === 'error') {
			setMainDataLoading(false);
			setLoading(false);
			setCurrentView('error');
		}
		getAnalysisReset();
	}, [getAnalysisState.apiState]);

	useEffect(() => {
		if (patientData && firstTime && id) {
			previewAppealLetter(
				patientData?.revenue_cycle === 'pre_service' ||
					patientData?.revenue_cycle === 'pre_service_part_c'
					? 'pre'
					: 'post',
			);
		}
	}, [patientData, firstTime]);

	useEffect(() => {
		if (getAppealLetterState.apiState === 'loading') {
			setLoading(true);
			setCurrentView('loader');
			setAppealLetterLoading(true);
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'thinking',
					response: 'Fetching Appeal Letter...',
					action: 'generate_appeal_letter',
					component: 'appeal_letter',
					parameters: {
						case_id: id,
					},
				});
			}
		}
		if (getAppealLetterState.apiState === 'success') {
			setLoading(false);
			setFirstTime(false);
			setAppealLetterLoading(false);
			setAppealLetterContent(getAppealLetterState.data.appeal_letter);
			setAppealLetterHeader(getAppealLetterState.data.header);
			setAppealLetterFooter(getAppealLetterState.data.footer);
			if (isAnalyse) {
				getAnalysis({ id: id, process_type: 'rc' });
			}
			if (editAppealLetterSelected || editFlag) {
				setShowEditAppealLetter(true);
				setEditFlag(false);
			}
			setIsAnalyse(true);
			if (currentViewSetter === 'preview') {
				setCurrentView('preview');
			} else if (currentViewSetter === 'send_appeal_letter') {
				setCurrentView('send_appeal_letter');
			} else if (currentViewSetter === 'download_appeal_letter') {
				setCurrentView('download_appeal_letter');
			}
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response: 'Appeal Letter fetched successfully',
					action: 'generate_appeal_letter',
					component: 'appeal_letter',
					parameters: {
						case_id: id,
					},
					store_message: true,
				});
			}
		} else if (getAppealLetterState.apiState === 'error') {
			setAppealLetterLoading(false);
			setLoading(false);
			setCurrentView('error');
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response: 'Unable to get Appeal Letter',
					action: 'generate_appeal_letter',
					component: 'appeal_letter',
					parameters: {
						case_id: id,
					},
					store_message: true,
				});
			}
			notification.error({
				message: getAppealLetterState.message
					? getAppealLetterState.message
					: 'Unable to get Appeal Letter content',
			});
		}
		getAppealLetterReset();
	}, [getAppealLetterState.apiState]);

	const getCodingTeamButtonFunction = (status, remark, value) => {
		if (patientData?.appeal_letter_status === 'coding_team_sent') {
			return codingTeamApproved(status, remark, value);
		}
	};

	const codingTeamApproved = (status, remark, coding_team_status) => {
		setAppealLetterLoading(true);
		editCase({
			id: id,
			status: status,
			status_remarks: `Appeal letter ${remark}`,
			appeal_letter: appealLetterContent,
			type: appealLetterType,
			coding_team_status: coding_team_status,
		});
	};

	useEffect(() => {
		if (getVerifyApproveAppealLetterUserListState.apiState === 'success') {
			let dropdown = [];
			getVerifyApproveAppealLetterUserListState.data.map((ele) => {
				return dropdown.push({
					label: `${ele.name}`,
					value: ele._id,
				});
			});
			setAppealLetterUsers(dropdown);
			getVerifyApproveAppealLetterUserListReset();
		} else if (
			getVerifyApproveAppealLetterUserListState.apiState === 'error'
		) {
			setAppealLetterUsers([]);
			notification.error({
				message: 'Unable to save Appeal Letter content',
			});
			getVerifyApproveAppealLetterUserListReset();
		}
	}, [getVerifyApproveAppealLetterUserListState]);

	useEffect(() => {
		if (editCaseState.apiState === 'loading') {
			setAppealLetterLoading(true);
		}
		if (editCaseState.apiState === 'success') {
			if (sendLetterLoading) {
				//todo
				setCurrentView('');
				// navigate(`/case/filings/${id}`);
				setSendLetterLoading(false);
			}
			if (
				editCaseState.data.appeal_letter_status ===
				'md_advisor_approved'
			) {
				setCurrentView('download_appeal_letter');
				setCurrentViewSetter('download_appeal_letter');
			}
			getAnalysis({ id: id });
			appealForm.setFieldsValue({
				appeal_letter_assigned_to: '',
				appeal_letter_remarks: '',
			});
			appealForm.resetFields('');
			setSelectMember(1);
		} else if (editCaseState.apiState === 'error') {
			setAppealLetterLoading(false);
			setSendLetterLoading(false);
			setDownloadLoading(false);
			notification.error({
				message: 'Unable to confirm Appeal letter',
			});
		}
		editCaseReset();
	}, [editCaseState.apiState]);

	useEffect(() => {
		if (getAnalysisState.apiState === 'loading') {
			setMainDataLoading(true);
		}
		if (getAnalysisState.apiState === 'success') {
			setLoading(false);
			setMainDataLoading(false);
			setAppealLetterLoading(false);
			setPatientData(getAnalysisState.data.case_details);
		}
		if (getAnalysisState.apiState === 'error') {
			setMainDataLoading(false);
		}
		getAnalysisReset();
	}, [getAnalysisState.apiState]);

	useEffect(() => {
		if (saveAppealLetterState.apiState === 'loading') {
			console.log(
				'saveAppealLetterState.apiState',
				saveAppealLetterState.apiState,
			);
			setAppealLetterLoading(true);
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'thinking',
					response: 'Saving Appeal Letter...',
					action: 'generate_appeal_letter',
					component: 'appeal_letter',
					parameters: {
						case_id: id,
					},
				});
			}
		}
		if (saveAppealLetterState.apiState === 'success') {
			console.log(
				'saveAppealLetterState.apiState',
				saveAppealLetterState.apiState,
			);
			setAppealLetterContent('');
			setAppealLetterHeader('');
			setAppealLetterFooter('');
			setEditAppealLetterLoading(false);
			setShowEditAppealLetter(false);
			setAppealLetterLoading(false);
			setLoading(true);
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response: 'Appeal Letter saved successfully',
					action: 'generate_appeal_letter',
					component: 'appeal_letter',
					parameters: {
						case_id: id,
					},
					store_message: true,
				});
			}
			getAppealLetter({
				id: id,
				type: appealLetterType,
				regenerate_appeal_letter: false,
			});
			saveAppealLetterReset();
		} else if (saveAppealLetterState.apiState === 'error') {
			setAppealLetterLoading(false);
			setShowEditAppealLetter(false);
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response: 'Unable to save Appeal Letter content',
					action: 'generate_appeal_letter',
					component: 'appeal_letter',
					parameters: {
						case_id: id,
					},
					store_message: true,
				});
			}
			notification.error({
				message: 'Unable to save Appeal Letter content',
			});
			saveAppealLetterReset();
		}
	}, [saveAppealLetterState.apiState]);

	const sendAppealLetterForApproval = (formValues) => {
		setAppealLetterLoading(true);
		editCase({
			appeal_letter_remarks: formValues.appeal_letter_remarks,
			appeal_letter_assigned_to: formValues.appeal_letter_assigned_to,
			id: id,
			status: 'letter_prepared',
			status_remarks: 'Appeal Letter Sent for approval',
			appeal_letter: appealLetterContent,
			type: appealLetterType,
			send_for_approval: true,
		});
	};

	const handleTabsChange = (key) => {
		setActiveKey(key);
		if (key === '1') {
			setIsAppealVerifyApproveModalOpen([
				'Send To Coding Team for Verification',
				sendToCodingTeam,
				'coding-team',
			]);
		} else {
			setIsAppealVerifyApproveModalOpen([
				'Send To MD Advisor for Approval',
				sendAppealLetterForApproval,
				'md-advisor',
			]);
		}
		setSelectMember(1);
		setAppealLetterUsers([]);
		appealForm.resetFields('');
		appealForm.setFieldsValue({});
	};

	const confirmAppealLetter = (status) => {
		setAppealLetterLoading(true);
		editCase({
			id: id,
			status: 'letter_prepared',
			status_remarks: 'Appeal letter confirmed',
			appeal_letter: appealLetterContent,
			type: appealLetterType,
			appeal_letter_status: status,
		});
	};

	const editAppealLetterFromModal = () => {
		// editAppealLetter(appealLetterType);
		setShowEditAppealLetter(true);
	};

	const closeEditAppealLetter = () => {
		setShowEditAppealLetter(false);
		setEditAppealLetterSelected(false);
	};

	const saveAndPreviewAppealLetter = () => {
		if (editorRef.current) {
			setEditAppealLetterLoading(true);
			setEditAppealLetterSelected(false);
			saveAppealLetter({
				id: id,
				appeal_letter: editorRef.current.getContent(),
				type: appealLetterType,
			});
		}
	};

	useEffect(() => {
		patientData?.appeal_letter_status === 'md_advisor_sent' &&
		patientData?.case_amount >=
			patientData?.appeal_letter_approval_threshold
			? setIsMdDisabled(true)
			: patientData?.appeal_letter_status === 'md_advisor_sent' &&
			  patientData?.case_amount <
					patientData?.appeal_letter_approval_threshold &&
			  checkModulePermissions('appeal-letter')
			? setIsMdDisabled(true)
			: checkModulePermissions('appeal-letter')
			? localStorage.getItem('role') === 'coding-team' ||
			  localStorage.getItem('role') === 'md-advisor'
				? setIsMdDisabled(true)
				: // .sub_modules.includes(
				// 		'confirm-letter',
				//   )
				//   localStorage.getItem('role') !== 'coding-team' &&
				//   localStorage.getItem('role') !== 'md-advisor' &&
				[
						'md_advisor_sent',
						'md_advisor_approved',
						'coding_team_sent',
				  ].includes(patientData.appeal_letter_status)
				? setIsMdDisabled(true)
				: patientData?.case_amount <
						patientData?.appeal_letter_approval_threshold &&
				  checkModulePermissions('appeal-letter')
				? //   .sub_modules.includes(
				  // 		'confirm-letter',
				  //   )
				  setIsMdDisabled(false)
				: localStorage.getItem('role') !== 'md-advisor'
				? setIsMdDisabled(false)
				: setIsMdDisabled(true)
			: setIsMdDisabled(true);
	}, [patientData]);

	useEffect(() => {
		if (
			patientData?.appeal_letter_status === 'coding_team_sent' ||
			localStorage.getItem('role') === 'coding-team' ||
			localStorage.getItem('role') === 'md-advisor' ||
			patientData?.appeal_letter_status === 'md_advisor_sent'
		) {
			setIsCodingDisabled(true); // Condition met, disable
		} else {
			setIsCodingDisabled(false); // Condition not met, enable
		}
	}, [patientData]);

	useEffect(() => {
		checkModulePermissions('appeal-letter').sub_modules.includes(
			'share-letter',
		) &&
			patientData.appeal_letter_status === 'md_advisor_approved' &&
			setCurrentView('download_appeal_letter');
	}, [patientData]);

	const dateOfBirth = (inputDateString) => {
		const date = new Date(inputDateString);

		// Extract the year, month, and day components from the Date object
		const year = date.getFullYear();
		const month = date.getMonth() + 1; // Month is zero-based, so add 1
		const day = date.getDate();

		// Format the date as "YYYY-MM-DD" or any desired format
		return `${year}-${month.toString().padStart(2, '0')}-${day
			.toString()
			.padStart(2, '0')}`;
	};

	useEffect(() => {
		if (displayEmailContent && !letterDownloaded) {
			getDownloadSignedURL();
			setDownloadLoading(true);
		}
	}, [displayEmailContent]);

	const handleEmailSend = () => {
		const subject = `Case Details: ${patientData.patient_first_name} ${patientData.patient_last_name} (MRN: ${patientData.mrn})`;
		const body = `Hi,\n\nI hope this email finds you well. Below are the case details regarding denials made by ${
			patientData.insurance_company?.name || ''
		}.\n\nMRN: ${patientData.mrn}\nName: ${
			patientData.patient_first_name
		} ${patientData.patient_last_name}\nAge: ${moment(
			patientData.date_of_birth,
		).fromNow(true)},\nGender: ${
			patientData.gender ? toTitleCase(patientData.gender) : ''
		}\nDOB: ${
			patientData.date_of_birth
				? dateOfBirth(patientData.date_of_birth)
				: ''
		}\nState: ${patientData.state}\nInsurance Company: ${
			patientData.insurance_company?.name || '-'
		}\n\nClinical Summary: ${patientData.clinical_summary}.`;
		const mailtoLink = `mailto:?subject=${encodeURIComponent(
			subject,
		)}&body=${encodeURIComponent(body)}`;
		// Open the email client
		window.open(mailtoLink);
		// setDisplayEmailContent(false);
		// setLetterDownloaded(false);
		setDownloadLoading(false);
		editCase({
			id: id,
			appeal_status: 'sent',
			appeal_status_updated_at: moment(),
		});
		// navigate(-1);
		// generateAppealLetterReset();
	};

	const getDownloadSignedURL = async () => {
		try {
			let length = patientData.appeal_letter_logs.length - 1;
			const response = await axios.get(
				`${config.api.base_url}/settings/get-Appeal-Signed-Url?fileName=${patientData.appeal_letter_logs[length]?.url[0]?.url}`,
				{
					headers: {
						'Content-type': 'application/json; charset=UTF-8',
						Authorization: 'Bearer ' + getUserToken(),
					},
				},
			);
			let res = response.data;
			if (res.status === 1) {
				const pdfResponse = await fetch(res.data);
				const arrayBuffer = await pdfResponse.arrayBuffer();

				const blob = new Blob([arrayBuffer], {
					type: 'application/pdf',
				});
				saveAs(blob, 'Appeal-letter.pdf');

				notification.success({
					message: 'Appeal Letter downloaded',
				});

				if (displayEmailContent) {
					setDisplayEmailContent(true);
					setLetterDownloaded(true);
					setDownloadLoading(false);
				} else {
					editCase({
						id: id,
						appeal_status: 'sent',
						appeal_status_updated_at: moment(),
					});
					setDownloadLoading(false);
					setLetterDownloaded(false);
					setDisplayEmailContent(false);
					setDisplayFaxUpload(false);
					setSendLetterLoading(true);
					// navigate(-1);
				}

				setDownloadLoading(false);
			} else {
				setDownloadLoading(false);
				setLetterDownloaded(false);
				setDisplayEmailContent(false);
				setDisplayFaxUpload(false);
				notification.error({
					message: 'Unable to download Appeal Letter',
				});
			}
		} catch (error) {
			notification.success({
				message: 'Could not upload',
			});
			setDownloadLoading(false);
			setLetterDownloaded(false);
			setDisplayEmailContent(false);
			setDisplayFaxUpload(false);
			setDownloadLoading(false);
			console.error('Error occurred:', error);
		}
	};

	const previewAppealLetter = (type, regenerate = false) => {
		getAppealLetter({
			id: id,
			type: type ? type : appealLetterType,
			regenerate_appeal_letter:
				action === 're_generate_appeal_letter' ? true : regenerate,
		});
		setAppealLetterType(type);
	};

	const editAppealLetter = (type) => {
		getAppealLetter({ id: id, type: type });
		setEditAppealLetterSelected(true);
		setAppealLetterType(type);
	};

	// Render different views based on current state
	const renderComponent = () => {
		switch (currentView) {
			case 'skeleton':
				return (
					<XThemeVoiceAssTableCard>
						<div className="hasPadding">
							<Skeleton active paragraph={{ rows: 6 }} />
						</div>
					</XThemeVoiceAssTableCard>
				);
			case 'loader':
				return (
					<VAAppealLetterLoader
						setCurrentView={setCurrentView}
						action={action}
					/>
				);
			case 'preview':
				return (
					<VAAppealLetterPreview
						editAppealLetterFromModal={editAppealLetterFromModal}
						previewAppealLetter={previewAppealLetter}
						appealLetterHeader={appealLetterHeader}
						appealLetterContent={appealLetterContent}
						appealLetterFooter={appealLetterFooter}
						showEditAppealLetter={showEditAppealLetter}
						saveAndPreviewAppealLetter={saveAndPreviewAppealLetter}
						editAppealLetterLoading={editAppealLetterLoading}
						closeEditAppealLetter={closeEditAppealLetter}
						editorRef={editorRef}
						patientData={patientData}
						appealLetterType={appealLetterType}
						setLoading={setLoading}
					/>
				);
			case 'send_appeal_letter':
				return (
					<VASendAppealLetter
						action={action}
						isMdDisabled={isMdDisabled}
						isCodingDisabled={isCodingDisabled}
						activeKey={activeKey}
						handleTabsChange={handleTabsChange}
						appealForm={appealForm}
						isAppealVerifyApproveModalOpen={
							isAppealVerifyApproveModalOpen
						}
						selectMember={selectMember}
						setSelectMember={setSelectMember}
						appealLetterUsers={appealLetterUsers}
						getVerifyApproveAppealLetterUserList={
							getVerifyApproveAppealLetterUserList
						}
						patientData={patientData}
						setFormData={setFormData}
						formData={formData}
						appealLetterLoading={appealLetterLoading}
						getCodingTeamButtonFunction={
							getCodingTeamButtonFunction
						}
						confirmAppealLetter={confirmAppealLetter}
					/>
				);
			case 'download_appeal_letter':
				return (
					<VAAppealLetterDownload
						displayEmailContent={displayEmailContent}
						setDisplayFaxUpload={setDisplayFaxUpload}
						letterDownloaded={letterDownloaded}
						setDisplayEmailContent={setDisplayEmailContent}
						displayFaxUpload={displayFaxUpload}
						setLetterDownloaded={setLetterDownloaded}
						getDownloadSignedURL={getDownloadSignedURL}
						setDownloadLoading={setDownloadLoading}
						previewTitle={previewTitle}
						setSuccessModal={setSuccessModal}
						sendLetterLoading={sendLetterLoading}
						setSendLetterLoading={setSendLetterLoading}
						editCase={editCase}
						id={id}
						handleEmailSend={handleEmailSend}
					/>
				);
			case 'appeal_letter_shared':
				return <VAAppealLetterSentLoader />;
			case 'error':
				return (
					<XThemeVoiceAssTableCard>
						<div className="hasPadding">
							<p>
								An error occurred while generating the appeal
								letter. Please try again later.
							</p>
						</div>
					</XThemeVoiceAssTableCard>
				);
			default:
				return (
					<XThemeVoiceAssTableCard>
						<div className="hasPadding">
							<Skeleton active paragraph={{ rows: 6 }} />
						</div>
					</XThemeVoiceAssTableCard>
				);
		}
	};

	return <>{renderComponent()}</>;
};

const mapStateToProps = (state) => ({
	getAnalysisState: state.getAnalysis,
	getAnalysisStatusState: state.getAnalysisStatus,
	getAppealLetterState: state.getAppealLetter,
	editCaseState: state.editCase,
	getVerifyApproveAppealLetterUserListState:
		state.getVerifyApproveAppealLetterUserList,
	saveAppealLetterState: state.saveAppealLetter,
});

const mapDispatchToProps = (dispatch) => ({
	getAnalysis: (params) => dispatch(getAnalysisApi(params)),
	getAnalysisReset: () => dispatch(getAnalysisReset()),
	getAppealLetter: (params) => dispatch(getAppealLetterApi(params)),
	getAppealLetterReset: (params) => dispatch(getAppealLetterReset(params)),
	editCase: (params) => dispatch(editCaseApi(params)),
	editCaseReset: (params) => dispatch(editCaseReset(params)),
	getVerifyApproveAppealLetterUserList: (params) =>
		dispatch(getVerifyApproveAppealLetterUserListApi(params)),
	getVerifyApproveAppealLetterUserListReset: () =>
		dispatch(getVerifyApproveAppealLetterUserListReset()),
	saveAppealLetter: (params) => dispatch(saveAppealLetterApi(params)),
	saveAppealLetterReset: (params) => dispatch(saveAppealLetterReset(params)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(VAAppealLetterController);
